package com.shadowings.gero.util

import kotlinx.browser.window

actual fun getDeviceModel(): String = runCatching {
    window.navigator.userAgent
}.getOrDefault("Web")
